/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewings_HintInputs */

const cs_viewings_hint = /** @type {(inputs: Viewings_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naplánované a dokončené prohlídky této nemovitosti.`)
};

const en_viewings_hint = /** @type {(inputs: Viewings_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scheduled and completed viewings for this property.`)
};

/**
* | output |
* | --- |
* | "Scheduled and completed viewings for this property." |
*
* @param {Viewings_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const viewings_hint = /** @type {((inputs?: Viewings_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewings_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewings_hint(inputs)
	return cs_viewings_hint(inputs)
});